module.exports = __webpack_public_path__ + "static/media/leestafel-min.e380a275.png";